function getCurrentLangPackVer() {
  // Naming rule : yyyyMMDDvv
  // Ex: 2023/6/23 第一次更新 : 2023062301

  return 2026081803
}
module.exports = { getCurrentLangPackVer }
